enum SelectedView {
  ELEMENTS = 'elements',
  SUBSECTIONS = 'subsections'
}

export default SelectedView;
